import { noStoreFetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

/** Pending sales, polled every five seconds while `enabled` (a hidden panel stops polling). */
export default function useMempoolSales(enabled = true) {
	return useSwr(enabled ? `${API_URL}/mempool/sales` : null, noStoreFetcher, {
		refreshInterval: enabled ? 5000 : 0
	})
}
